import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, from, map, switchMap } from 'rxjs';
import { isTypeOfString } from '../../helpers/public-helpers';
import { WINDOW } from '../../shared/public-shared';

export interface BasketTransferData {
    transferGuid: string;
}

@Injectable({
    providedIn: 'root',
})
export class LibOsBasketService {
    public constructor(
        private http: HttpClient,
        @Inject(WINDOW) private window: Window
    ) {}

    public updateHeaderBasket(showNotification: boolean = true): Promise<void> {
        const displayHeaderNotification = (this.window as any).displayHeaderNotification;
        if (typeof displayHeaderNotification !== 'function') {
            return Promise.resolve();
        }

        return Promise.resolve(displayHeaderNotification(showNotification)).then(() => undefined);
    }

    public addTransferServiceToBasketAndWait(transferData: BasketTransferData | string): Observable<void> {
        const transferGuid = isTypeOfString(transferData) ? transferData : transferData.transferGuid;

        return this.http
            .get(`/os/c/main.do?addon=BASKET&action=READ_TRANSFER_SERVICE&page=BLANK&g=${transferGuid}`, {
                withCredentials: true,
                responseType: 'text',
            })
            .pipe(
                switchMap(() => from(this.updateHeaderBasket())),
                map(() => undefined)
            );
    }

    public addTransferServiceToBasket(transferData: BasketTransferData | string, callback?: () => void) {
        this.addTransferServiceToBasketAndWait(transferData).subscribe({
            next: () => callback?.(),
            error: (error) => {
                callback?.();
                console.error('An error occured adding item(s) to basket', error);
            },
        });
    }
}
